import React from 'react'

import { 
  MainInfoWrapper,
  Select,
  SearchArea, 
  NameWrapper, 
  PhoneNumberWrapper,
  Notice1,
  ApplyDateWrapper,
  ApplyLocationWrapper,
  AreaWrapper,
  Notice2
} from './styled'; 

import section_mainInfo_whiteBase from '../../assets/section_mainInfo_whiteBase.png'
import section_notice_1 from '../../assets/section_notice_1.png'
import section_notice_2 from '../../assets/section_notice_2.png'

const MainInputComponent = ({ state, onChangeHandler, openModal }) => {

  const { name, phone, date, address, roomSizeType } = state;
  //월선택
  const monthList = ["7", "8"];
  //지역타입선택
  const areaTypeList = [
    { value: 0, label: '10m²이하' },
    { value: 1, label: '10m²초과 ~ 20m²이하' },
    { value: 2, label: '20m²초과 ~ 30m²이하' },
    { value: 3, label: '30m²초과 ~ 40m²이하' },
    { value: 4, label: '이사 예정 (40m²이하)' }
  ];

  return(
    <MainInfoWrapper width={614} height={476} imgUrl={section_mainInfo_whiteBase} >
      <NameWrapper className='nameWrapper'>
        <span className='Title'>이름</span>
        <div className='Divider'>
          <svg width="2" height="18" viewBox="0 0 2 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="18" fill="#326CF9"/>
          </svg>
        </div>
        <p className='ContentText'>{name}</p>
      </NameWrapper>
      <PhoneNumberWrapper className='phoneNumberWrapper' >
        <span className='Title'>연락처</span>
        <div className='Divider'>
          <svg width="2" height="18" viewBox="0 0 2 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="18" fill="#326CF9"/>
          </svg>
        </div>
        <p className='ContentText'>{phone}</p>
      </PhoneNumberWrapper>
      <Notice1 className='notice1' src={section_notice_1}/>
      <ApplyDateWrapper className='applyDate'>
        <span className='Title'>신청 날짜</span>
        <div className='Divider'>
          <svg width="2" height="18" viewBox="0 0 2 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="18" fill="#326CF9"/>
          </svg>
        </div>
        <div className='ContentWrapper'> 
          <Select 
            name="date" 
            value={date} 
            onChange={onChangeHandler} 
            width={'42%'} 
          >
            <option value="">월 선택</option>
            {monthList.map(i => <option key={i} value={i}>{i}월</option>)}
          </Select>    
          <p className='Description'>7월/8월 일정 중 선택</p>  
        </div>
      </ApplyDateWrapper>
      <ApplyLocationWrapper className='applyLocation'>
        <span className='Title'>신청 지역</span>
        <div className='Divider'>
          <svg width="2" height="18" viewBox="0 0 2 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="18" fill="#326CF9"/>
              </svg>
        </div>
        <div className='ContentWrapper'>
          <SearchArea 
            onClick={openModal}
            width={'100%'} 
            value={address}
          >
            {address || '지역 선택'}
          </SearchArea>
        </div>
      </ApplyLocationWrapper>
      <AreaWrapper className='area'>
        <span className='Title'>전용 면적</span>
        <div className='Divider'>
          <svg width="2" height="18" viewBox="0 0 2 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="18" fill="#326CF9"/>
          </svg>
        </div>
        <div className='ContentWrapper'>
          <Select 
            name="roomSizeType" 
            value={roomSizeType ?? ''} 
            onChange={onChangeHandler} 
            width={'100%'} 
          >
            <option value="">면적 선택</option>
            {areaTypeList.map((obj, index) => <option key={index} value={obj.value}>{obj.label}</option>)}
          </Select>    
        </div>
      </AreaWrapper>
      <Notice2 className='notice2' src={section_notice_2}/>
    </MainInfoWrapper>
  )
};

export default MainInputComponent;